var util = require("../util");

module.exports = addSVGLabel;

function addSVGLabel(root, node) {
  var domNode = root;

  domNode.node().appendChild(node.label);

  util.applyStyle(domNode, node.labelStyle);

  return domNode;
}



//////////////////
// WEBPACK FOOTER
// ./~/dagre-d3/lib/label/add-svg-label.js
// module id = 1734
// module chunks = 0